export const FETCH_HOLIDAYS_REQUEST = "FETCH_HOLIDAYS_REQUEST";
export const FETCH_HOLIDAYS_SUCCESS = "FETCH_HOLIDAYS_SUCCESS";
export const FETCH_HOLIDAYS_FAIL = "FETCH_HOLIDAYS_FAIL";